import React from "react";
import { motion } from "framer-motion";

const DatoulaBanner = () => {
  return (
    <div className="w-full bg-white overflow-hidden select-none">
      <div className="relative w-full">
        <motion.div
          className="flex w-max animate-marquee hover:[animation-play-state:paused]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          {/* Duplicate text for seamless loop */}
          <h1 className="text-[12vw] font-bold text-[#E85114]/10 uppercase whitespace-nowrap tracking-tighter leading-none px-10">
            Datoula Solutions
          </h1>
          <h1 className="text-[12vw] font-bold text-[#E85114]/10 uppercase whitespace-nowrap tracking-tighter leading-none px-10">
            Datoula Solutions
          </h1>
        </motion.div>
      </div>
    </div>
  );
};

export default DatoulaBanner;
